<template>
    <div class="mt-2 mb-2" style="background-color: #fff">
        <v-layout row>
            <v-flex xs6>
                <v-layout row class="ml-0 mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Entered On:
                    </div>
                    <div>{{ row.enteredOn | time }}</div>
                </v-layout>
                <v-layout row class="ml-0 mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Pickup Date:
                    </div>
                    <div>{{ row.pickupDate | date }}</div>
                </v-layout>

                <v-layout
                    row
                    class="ml-0 mb-2"
                    v-for="prop in getRowProperties()"
                >
                    <div class="font-weight-medium mr-1 width-200">
                        {{ prop.name }}:
                    </div>
                    <div>{{ prop.value }}</div>
                </v-layout>
                <v-layout row class="ml-0 mb-2">
                    <div class="font-weight-medium mr-1 width-200">Amount:</div>
                    <div>{{ row.amount | currency }}</div>
                </v-layout>
                <v-layout row class="ml-0 mb-2" v-if="row.updatedAt">
                    <div class="font-weight-medium mr-1 width-200">
                        Updated At:
                    </div>
                    <div>{{ row.updatedAt | time }}</div>
                </v-layout>
            </v-flex>
            <v-flex xs6>
                <div
                    class="pickup-messages-scroll-down elevation-0"
                    style="background-color: #f1ffdc"
                >
                    <v-timeline
                        dense
                        class="petition-timeline mx-3"
                        style=""
                        v-if="messages.length"
                    >
                        <div
                            v-for="message in messages.filter(
                                (m) => m.paymentPickupID == row.id
                            )"
                        >
                            <v-timeline-item color="rgb(92, 184, 96)">
                                <v-card>
                                    <v-card-title
                                        style="background-color: rgb(92, 184, 96)"
                                        class=" py-1"
                                    >
                                        <h2
                                            class="body-1 my-0 white--text font-weight-light"
                                        >
                                            <div>
                                                <v-icon
                                                    dark
                                                    size="15"
                                                    class="mr-2"
                                                >
                                                    mdi-laptop-windows
                                                </v-icon>
                                                {{ message.dateTime | time }}
                                                {{ " - " + message.username }}
                                            </div>
                                            <div>
                                                FROM:
                                                {{ message.from | phone }}
                                                TO:
                                                {{ message.to | phone }}
                                            </div>
                                        </h2>
                                    </v-card-title>
                                    <v-container class="pa-3">
                                        <v-layout class="px-2 pt-1">
                                            <v-flex
                                                xs10
                                                class="py-0 body-2 account-message-text"
                                            >
                                                {{ message.text }}
                                            </v-flex>
                                        </v-layout>
                                        <v-layout
                                            row
                                            justify-end
                                            style="font-size: 11px"
                                        >
                                            <v-spacer></v-spacer>
                                            <div
                                                class="text-xs-right px-2 account-message-status"
                                                style=""
                                            >
                                                {{ message.status }}
                                            </div>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-timeline-item>
                        </div>
                    </v-timeline>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import { formatCurrency, except, toTitleCase } from "../../utils/helpers.js";
import moment from "moment";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            messages: [],
        };
    },
    async created() {
        this.loadMessages();
    },
    computed: {},
    methods: {
        async loadMessages() {
            const messages = await this.$http.post(
                "api/paymentpickup/GetPickupMessages",
                [this.row.id]
            );

            this.messages = messages;
        },
        formatCurrency(amount) {
            return formatCurrency(amount);
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "pickupDate",
                    "enteredOn",
                    "updatedAt",
                    "amount"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
    },
};
</script>
<style>
.pickup-messages-scroll-down {
    overflow-y: auto;
    height: 400px;
    display: flex;
    flex-direction: column-reverse;
}
.account-message-text {
    white-space: pre-line;
    margin-top: -20px;
}
.account-message-status {
    width: fit-content;
    background-color: purple;
    color: #fff;
    font-size: 11px;
    text-transform: uppercase;
}

.account-message-status-pending {
    background-color: rgb(253, 180, 0);
    cursor: pointer;
}

.account-message-status-completed {
    background-color: rgb(92, 184, 96);
}
</style>
